import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const propTypes = {
    children: PropTypes.node.isRequired,
    htmlFor: PropTypes.string.isRequired,
    className: PropTypes.string,
    isRequired: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isVisible: PropTypes.bool
};


const defaultProps = {
    className: null,
    isRequired: false,
    isDisabled: false,
    isVisible: true
};

export default function Label(props) {
    const { children, htmlFor, className, isRequired, isDisabled, isVisible } = props;
    
    let requiredIndicator = null;
    
    if (isRequired) {
        requiredIndicator = (
            <abbr className="rec-label-required-indicator" title="Required">
                <span aria-hidden="true">*</span>
                <span className="rec-sr-only"> (Required) </span>
            </abbr>
        )
    }
    
    const classes = cx('rec-label', className, {
        'rec-sr-only': !isVisible,
        'rec-label-required': isRequired,
        'rec-label-disabled': isDisabled
    });
    
    return (
        <label
            id={`${htmlFor}-label`}
            className={classes}
            htmlFor={htmlFor}>
            {children}
            {requiredIndicator}
        </label>
    );
}

Label.propTypes = propTypes;
Label.defaultProps = defaultProps;